/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import agCommon from './common';
import agApi from './api';
import agAdmin from './admin';
import agClient from './client';
import farmer from './agrolog-farmer';

import AgConfig from './ag.config';

export default angular.module('agrolog', [
    agCommon,
    agApi,
    agAdmin,
    agClient,
    farmer])
    .config(AgConfig)
    .name;
